import axios from "axios";
import {
    cuttingServicesPath,
} from "../../Constants";

const restUrl = cuttingServicesPath + '/cutting'

export default class CutFileService {

    static async downloadFile(workingCuttingMapId, cutFileNameType) {
        return axios.post(restUrl + '/cut-file' + "?workingCuttingMapId=" + workingCuttingMapId + "&cutFileNameType=" + cutFileNameType, [],{
            responseType: "arraybuffer"
        });
    }
}